import {
  createUnleashPlugin,
  initUnleashClients,
  updateUnleashContext
} from './unleash'

const UnleashPlugin = createUnleashPlugin()

// ponytail: Vue 2 shape — Vue.use(plugin). Pass the imported Vue from main.ts.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initUnleashFeatureFlags = async (Vue: any): Promise<void> => {
  if (
    !process.env.VUE_APP_FCS_OPENFEATURE_URL ||
    !process.env.VUE_APP_FCS_OPENFEATURE_CLIENT_KEY ||
    !process.env.VUE_APP_FCS_OPENFEATURE_APP_NAME
  ) {
    console.warn(
      'Unleash environment variables are not set. Skipping Unleash initialization.'
    )
    return
  }
  try {
    Vue.use(UnleashPlugin)
    await initUnleashClients()
    updateUnleashContext({
      environment: process.env.VUE_APP_ENVIRONMENTS || 'development'
    })
  } catch (error) {
    console.error('Failed to initialize Unleash:', error)
  }
}

export { FcsFlag, BcsFlag } from './unleash'
